var exports = {
  "list": "xae11d333--95f5e7--list",
  "list-desktop": "xae11d333--95f5e7--list-desktop",
  "list-phone": "xae11d333--95f5e7--list-phone",
  "list-tablet": "xae11d333--95f5e7--list-tablet",
  "item": "xae11d333--95f5e7--item",
  "item-desktop": "xae11d333--95f5e7--item-desktop",
  "item-phone": "xae11d333--95f5e7--item-phone",
  "item-tablet": "xae11d333--95f5e7--item-tablet",
  "logo-container": "xae11d333--95f5e7--logo-container",
  "logo-container-phone": "xae11d333--95f5e7--logo-container-phone",
  "logo-container-tablet": "xae11d333--95f5e7--logo-container-tablet",
  "logo": "xae11d333--95f5e7--logo",
  "content": "xae11d333--95f5e7--content",
  "info": "xae11d333--95f5e7--info",
};

module.exports = exports;
